<template>
  <div>
  <b-navbar class="main-navbar" toggleable="lg" type="dark" variant="primary">
    <b-container>
      <b-navbar-brand href="/">
        <img src="../assets/logo.webp" width="150"/>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <li class="nav-item">
            <router-link class="nav-link" to="/">Calculadora</router-link>
          </li>

          <li class="nav-item">
            <router-link class="nav-link" to="/consulta-regras">Consulta Nacional</router-link>
          </li>

          <li class="nav-item">
            <a class="nav-link" href="https://genialprev.curseduca.pro/" target="_blank">Treinamentos</a>
          </li>

          <li class="nav-item">
            <router-link class="nav-link" to="/bancada">Bancada GenIA</router-link>
          </li>

          <li class="nav-item">
            <a class="nav-link" id="trial-tooltip" v-if="userType === 'registered' && isTrial" v-b-tooltip.hover v-bind:title="'Disponível após período de teste'">Comunidade Whatsapp</a>
            <a class="nav-link" href="https://chat.whatsapp.com/DNIS9oJB79xKPBfOpfIEli" target="_blank" v-if="userType === 'registered' && !isTrial">Comunidade Whatsapp</a>
            <a class="nav-link" href="https://chat.whatsapp.com/EMfkCrIxNB7GDOzyLTQbTK" target="_blank" v-if="userType === 'created'">Comunidade Whatsapp</a>
          </li>

          <li class="nav-item">
            <a class="nav-link" href="https://wa.me/5519984511962" target="_blank">Suporte Técnico</a>
          </li>

          <!-- <li class="nav-item">
            <router-link id="employees-nav" class="nav-link" to="/online-classes">
             <i
              class="fa fa-lock"
              v-if="isOnFirstSevenDays"
              ></i>
             Video Aulas
            </router-link>
          </li> -->

          <!-- <li class="nav-item">
            <router-link id="employees-nav" class="nav-link" to="/mindmaps">
            <i class="fa fa-lock" v-if="isOnFirstSevenDays"></i>
             Mapas Mentais
            </router-link>
          </li> -->

        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto" id="account-nav">
          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template v-slot:button-content>
              <em>{{sessionUser.name}}</em>
            </template>
            <b-dropdown-item href="#" @click="myAccount">Minha conta</b-dropdown-item>
            <b-dropdown-item href="#" @click="logout">Sair</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>

  <!-- Admin Sub-Navigation Bar -->
  <div class="admin-subnav" v-if="isManagement">
    <b-container class="d-flex align-items-center">
      <span class="admin-badge">Admin</span>
      <nav class="admin-nav">
        <router-link class="admin-nav-link" to="/users">
          <i class="fa fa-users"></i> Usuários
        </router-link>
        <router-link class="admin-nav-link" to="/management/accounts">
          <i class="fa fa-building"></i> Contas
        </router-link>
        <router-link class="admin-nav-link" to="/management/indexes">
          <i class="fa fa-chart-line"></i> Índices
        </router-link>
        <router-link class="admin-nav-link" to="/management/retirement-factors">
          <i class="fa fa-calculator"></i> Fator Previdenciário
        </router-link>
        <router-link class="admin-nav-link" to="/management/chat-monitor">
          <i class="fa fa-desktop"></i> Monitor IA
        </router-link>
        <router-link class="admin-nav-link" to="/management/agent-configurator">
          <i class="fa fa-cogs"></i> Configurador GenIAs
        </router-link>
        <!-- #580: painel SaaS é app separado (/painel/), sempre pede login próprio -->
        <a class="admin-nav-link" href="/painel/" target="_blank" rel="noopener noreferrer">
          <i class="fa fa-line-chart"></i> Painel SaaS
        </a>
      </nav>
    </b-container>
  </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  name: 'NavBar',
  computed: {
    ...mapGetters(['sessionUser', 'isOnFirstSevenDays', 'isManagement']),
    userType() {
      if (this.sessionUser.trialAsaasExpiration) return 'registered';

      return 'created';
    },
    isTrial() {
      if (this.userType == 'created') return false;
      
      return moment().isBefore(moment(this.sessionUser.trialAsaasExpiration));
    },
  },
  methods: {
    logout: function () {
      this.$store.dispatch('LOGOUT').then(() => {
        this.$router.push('/login');
      }).catch((e) => {
        console.info('Logout Error');
        console.error(e);
      });
    },
    myAccount: function () {
      this.$router.push(`/users/${this.sessionUser.id}/edit`).catch(err => {});
    }
  },
  mounted() {
    const intro = this.$intro();
    intro.setOptions({
      nextLabel: "Próximo",
      prevLabel: "Anterior",
      doneLabel: "Fechar",
      skipLabel: "Pular",
      steps: [{
        intro: 'Seja bem vindo ao teste de Luiz Carraro'
      }, {
        element: "#employees-nav",
        intro: 'Aqui está o controle de funcionários'
      }, {
        element: "#users-nav",
        intro: 'Aqui pode-se controlar os usuários de acesso a esta aplicação'
      }, {
        element: "#account-nav",
        intro: 'Aqui você pode trocar a sua senha ou sair da aplicação'
      }]
    });

    // intro.start();
  }
}
</script>

<style>
.navbar.main-navbar {
  position: sticky;
  top: 0;
  z-index: 999;
}

.nav-link.introjs-showElement {
  color: black !important;
}
.navbar-brand {
  font-size: 10pt;
}
.navbar {
  background-color: #0b6baf;
}

/* Admin Sub-Navigation Bar */
.admin-subnav {
  background-color: #084d80;
  position: sticky;
  top: 56px; /* height of main navbar */
  z-index: 998;
  padding: 6px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.admin-badge {
  background-color: rgba(255, 255, 255, 0.2);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 3px 8px;
  border-radius: 3px;
  margin-right: 16px;
  white-space: nowrap;
}

.admin-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.admin-nav-link {
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: 13px;
  padding: 4px 10px;
  border-radius: 4px;
  text-decoration: none !important;
  transition: background-color 0.15s, color 0.15s;
  white-space: nowrap;
}

.admin-nav-link:hover {
  background-color: rgba(255, 255, 255, 0.15);
  color: #fff !important;
}

.admin-nav-link.router-link-active,
.admin-nav-link.router-link-exact-active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #fff !important;
  font-weight: 500;
}

.admin-nav-link i {
  margin-right: 4px;
  font-size: 12px;
}
</style>
